import Vue from 'vue';

import App from '@/App.vue';
import '@/registerServiceWorker';
import router from '@/router';
import store from '@/store';

/* Plugins */
import '@/plugins/vue-fontawesome';
import '@/plugins/vue-js-modal';
import '@/plugins/vue2-google-maps';
import '@/plugins/layouts';
import '@/plugins/auth0';
import { createProvider } from '@/plugins/apollo/vue-apollo';
import i18n from '@/plugins/i18n';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  apolloProvider: createProvider(),
  render: (h) => h(App),
}).$mount('#app');
